<template>
  <div>
    <section class="encabezado encuesta-medicina -padres row-start">
      <img class="logo" src="/img/logoFamilias.svg" alt="Logo UFV Familias">
    </section>
    <section class="contenedor-encuesta row-between" id="encuesta">
      <h2>Formulario de inscripción</h2>
      <legend>Datos personales</legend>
      <ValidationObserver ref="form" v-slot="{ failed, valid }">
        <form
          class="row-between fww paso"
          @submit.prevent="validate"
          :valid="valid"
          autocomplete="off"
        >
          <div class="contenedor-input half">
            <ValidationProvider
              rules="required|min:3"
              v-slot="{ errors, ariaInput, ariaMsg, classes }"
            >
              <input
                autocomplete="off"
                type="text"
                name="name"
                placeholder="Nombre*"
                v-model="data.name"
                :class="classes"
              />
              <span v-bind="ariaMsg" class="custom-error">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>

          <div class="contenedor-input half">
            <ValidationProvider
              rules="required|min:3"
              v-slot="{ errors, ariaInput, ariaMsg, classes }"
            >
              <input
                autocomplete="off"
                type="text"
                name="surname"
                placeholder="Primer apellido*"
                v-model="data.surname"
                :class="classes"
              />
              <span v-bind="ariaMsg" class="custom-error">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>

          <div class="contenedor-input half">
            <ValidationProvider
              rules="min:3"
              v-slot="{ errors, ariaInput, ariaMsg, classes }"
            >
              <input
                autocomplete="off"
                type="text"
                name="surname_2"
                placeholder="Segundo apellido"
                v-model="data.surname_2"
                :class="classes"
              />
              <span v-bind="ariaMsg" class="custom-error">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>

          <div class="contenedor-input half">
            <ValidationProvider
              rules="required|min:9"
              v-slot="{ errors, ariaInput, ariaMsg, classes }"
            >
              <input
                autocomplete="off"
                type="text"
                name="phone"
                placeholder="Teléfono/móvil*"
                v-model="data.phone"
                :class="classes"
              />
              <span v-bind="ariaMsg" class="custom-error">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>


          <div class="contenedor-input half">
            <ValidationProvider
              rules="required|email"
              v-slot="{ errors, ariaInput, ariaMsg, classes }"
            >
              <input
                autocomplete="off"
                type="text"
                name="email"
                placeholder="Correo electrónico*"
                :class="classes"
                v-model="data.email"
              />
              <span v-bind="ariaMsg" class="custom-error">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
          <div class="contenedor-input half">
            <ValidationProvider
              rules="required|min:3"
              v-slot="{ errors, ariaInput, ariaMsg, classes }"
            >
              <input
                autocomplete="off"
                type="text"
                name="address"
                placeholder="Dirección completa*"
                :class="classes"
                v-model="data.address"
              />
              <span v-bind="ariaMsg" class="custom-error">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>



          <legend>Datos hijo/s</legend>
          <div class="contenedor-input -check">
            <input
              type="checkbox"
              id="no-hijos"
              v-model="notsons"
              name="nohijos"
            />
            <label for="no-hijos"
              >No tengo hijos que hayan estudiado en la UFV</label
            >
          </div>

          <template v-if="notsons">
            <div class="contenedor-input half">
              <ValidationProvider
                rules="required"
                v-slot="{ errors, ariaInput, ariaMsg, classes }"
              >
                <select
                  id="family_type"
                  name="family_type"
                  v-model="data.family[0].type"
                  :class="classes"
                >
                  <option value="">Selecciona tu relación con UFV</option>
                  <option value="5">Soy PAS</option>
                  <option value="6">Soy PROF</option>
                  <option value="1">Soy Amigo</option>
                  <option value="9">Soy Club Sénior</option>
                </select>
                <span v-bind="ariaMsg" class="custom-error">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
          </template>

          <template v-if="!notsons">
            <div v-for="(child, key) in data.family" :key="key" :value="key">
              <h4>Hijo {{ key + 1 }}</h4>
              <div class="row-between fww">
                <div class="contenedor-input half">
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors, ariaInput, ariaMsg, classes }"
                  >
                    <input
                      autocomplete="off"
                      type="text"
                      name="name"
                      placeholder="Nombre*"
                      v-model="child.name"
                      :class="classes"
                    />
                    <span v-bind="ariaMsg" class="custom-error">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>
                <div class="contenedor-input half">
                  <ValidationProvider
                    rules="numeric"
                    v-slot="{ errors, ariaInput, ariaMsg, classes }"
                  >
                    <input
                      autocomplete="off"
                      type="number"
                      name="name"
                      placeholder="Año de Ingreso"
                      v-model="child.start_ufv_year"
                      :class="classes"
                    />
                    <span v-bind="ariaMsg" class="custom-error">{{
                      errors[0]
                    }}</span>
                  </ValidationProvider>
                </div>
                <div class="contenedor-input">
                  <ValidationProvider
                    v-slot="{ errors, ariaInput, ariaMsg, classes }"
                  >
                    <autocomplete
                      :class="classes"
                      :name="'study' + key"
                      :label="'Estudios que realiza en la UFV'"
                      :type="'study'"
                      v-model="child.studies"
                      :idkey="'id'"
                      :formtype="'select'"
                      @input="setChildStudy($event, key)"
                    ></autocomplete>
                  </ValidationProvider>
                </div>
              </div>
            </div>
            <a @click="addChild" class="action-btn">Añadir más hijos/as</a>
          </template>

          <div class="contenedor-input -check">
            <ValidationProvider
              rules="required"
              v-slot="{ errors, ariaInput, ariaMsg, classes }"
            >
              <input
                type="checkbox"
                id="id"
                :class="classes"
                v-model="data.politica"
                name="politica"
              />
              <label for="id">
                He leído y acepto la
                <a
                  href="https://www.ufv.es/politica-privacidad-alumni"
                  target="_blank"
                >
                  Política de privacidad
                </a>
              </label>
              <span v-bind="ariaMsg" class="custom-error">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
          <a @click="validate" class="boton-azul" :class="{loading:loading}">Enviar</a>
        </form>
      </ValidationObserver>

      <div class="form-popup-encuesta" :show="!!dialog">
        <div class="popup" v-if="dialog">
          <h2>{{ dialog.titulo }}</h2>
          <p>{{ dialog.cuerpo }}</p>

          <a
            v-if="dialog.btnPadres"
            href="https://www.ufv.es/otros-servicios/familias-ufv/"
            class="boton-azul"
            >Ir a UFV Familias</a
          >
          <a v-else @click="dialog = null" class="boton-azul">Aceptar</a>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";


export default {
  name: "formulario-padres",
  computed: {
    ...mapGetters({
      dominios: "getDominios",
    }),
  },
  mounted() {
    console.log(this.$route.query.event_id);
    this.data.event_id = this.$route.query.event_id;
    document.title = "UFV Familias";
  },
  data: () => ({
    data: {
      name: "",
      surname: "",
      surname_2: "",
      email: "",
      phone: "",
      address: "",
      event_id: "",
      family: [
        {
          name: "",
          type: 4,
          studies: [],
          comment: "Alta desde Registro UFV Familias",
        },
      ]
    },
    defaultChild: {
      name: "",
      type: 4,
      studies: [],
      comment: "Alta desde Registro UFV Familias",
    },
    other_bowl: null,
    error: null,
    clicked: false,
    notsons: false,
    dialog: null,
    loading: false,
  }),
  methods: {
    validate() {
      this.$refs.form.validate().then((success) => {
        if (success) {
          this.loading = true;
          this.data.familiar_bowl = true;
        
          axios
            .post("/api/auth/register", this.data)
            .then((response) => {
                this.loading = false;
                this.printDialog(response);
                this.$refs.form.reset();
            })
            .catch((response) => {
                this.loading = false;
                this.printDialog(response.response);
            })
        } else {
          const invalidField = this.$refs.form.$children.find((e) => !e.valid)
          if (invalidField)
            invalidField.$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center',
            })
        }
      });
    },
    printDialog(response) {
      if (response == null) {
        this.dialog = {
          titulo: "Error General",
          cuerpo: "Por favor contacte con soporte",
        };
      } else if (response.data && response.data.status) {
        this.dialog = {
          titulo: "¡Enhorabuena!",
          cuerpo: "Te has registrado correctamente.",
          btnPadres: true,
        };
        this.reset();
      } else if (response.data.messages) {
        this.dialog = {
          titulo: "Error",
          cuerpo: response.data.messages[0].message,
        };
      }
    },
    reset() {
      this.clicked = false;
      this.data = {
        name: "",
        surname: "",
        surname_2: "",
        gender: 0,
        email: "",
        phone: "",
        address: "",
        document: "",
        document_type: "",
        family: []
      };
    },
    reload() {
      location.reload();
    },
    addChild() {
      this.data.family.push({ ...this.defaultChild });
    },
    setChildStudy(event, key) {
      this.data.family[key].studies =
        event && event.id != null ? event.id : null;
    },
  },
  watch: {
    notsons: function (newValue) {
      if (newValue == false) {
        this.data.family = [{ ...this.defaultChild }];
      } else {
        this.data.family = [{ ...this.defaultChild }];
        this.data.family[0].type = 1;
      }
    },
  },
};
</script>

<style lang="scss" scoped>

#encuesta * {
  font-family: "Arimo", sans-serif !important;
}
.contenedor-input input[type="checkbox"] + label,
.contenedor-input input[type="radio"] + label {
  width: auto;
  margin-right: 50px;
  margin-bottom: 10px;
}

.contenedor-input input[type="checkbox"],
.contenedor-input input[type="radio"] {
  pointer-events: none;
}

.contenedor-input.-check {
  margin-top: 30px;
  margin-bottom: 30px;
}

.contenedor-input select {
  width: 100%;
}

.action-btn {
  width: 100%;
  display: inline-block;
  text-decoration: underline;
  color: #003466;
  margin-bottom: 20px;
}

.action-btn.-red {
  color: red;
}

h4 {
  width: 100%;
  display: inline-block;
  font-weight: bold;
  margin-bottom: 10px;
}

.responsive {
  display: none;
}

.paso input {
  padding-left: 0 !important;
}

@media screen and (max-width: 895px) {
  .responsive {
    display: block;
  }

  .pc {
    display: none;
  }
}
</style>
